<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-6 col-centered create-report-card">
                <div class="card p-4">
                    <div class="col-centered text-center">
                        <div class="custom-title pt-7">
                            Upload Document
                        </div>
                        <div class="custom-subheading pt-3">
                            Upload a pdf documents to be signed by two parties and veriy it on the blockchain.
                        </div>
                    </div>
                    <div class="form-body p-10 mt-7">
                        <div class="text-center">
                            <div class="upload-verify-wrapper">
                                <img alt="cloud" src="/media/misc/cloud-upload.png" width="60px"/>

                                <label class="file-upload btn btn-upload btn-success mt-5 font-weight-bolder font-size-sm"
                                       for="fileUpload">
                                    <i class="fa fa-upload mr-2"></i> Upload
                                    <input @change="onUpload" accept="application/pdf" formenctype="multipart/form-data" id="fileUpload"
                                           type="file"/>
                                </label>

                                <label class="pt-2 font-small text-primary">(up to 10MB)</label>
                                <div class="btn btn-faded-xx mt-5 font-weight-bolder font-size-sm">
                                    Only PDF is supported
                                </div>
                            </div>
                        </div>
                        <div style="padding-top: 1.9rem !important;">
                            <div class="upload-container progress-container-success" ref="upload_container"
                                 style="display: none">
                                <div class="progress-features" style="width: auto;">

                                    <div class="progress-compile-iconWrapper">
                                        <i class="mdi mdi-file-pdf-outline progress-compile-icon-fade"></i>
                                    </div>

                                    <div class="progress-compile-dataWrapper position-relative">

                                        <div class="upload-info">{{ swap.upload_title }}</div>

                                        <div class="progress-compile-percent text-primary"
                                             style="right: 20px; font-size: 10px;"> Cancel
                                        </div>

                                        <div class="progress progress-xs w-100">
                                            <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="50"
                                                 class="progress-bar bg-faded"
                                                 role="progressbar" style="width: 0%;"></div>
                                        </div>
                                        <div class="peecent-state--Wrapper text-primary">
                                            %0 Uploaded
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p class="error" href="#" style="display: none">
                            Server encountered error, please try again
                        </p>

                        <!--list of blockchains-->
                        <app-list-of-blockchains />

                        <div class="text-center pt-10 mb-10">
                            <button :class="{'disabled': utils.is_btn_loading || !utils.is_upload_done}"
                                    @click="proceedToCompilling()"
                                    class="btn btn-success font-weight-bold custom-btn-create-report px-6 py-3">
                                Proceed
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

   import {bus} from '../../main';
   import timerMixin from '../../core/mixins/timerMixin';
   import {
      CHANGE_COMPONENT,
      SAVE_REPORT_FIELDS,
      SAVE_TEMP_PDF_FILE,
   } from '../../core/store/modules/report';
   import ListOfBlockchains from '../content/custom/ListOfBlockchains';

   export default {
      name: "Report.Timeproof.init",
      data() {
         return {
            utils: {
               is_btn_loading: false,
               is_upload_done: false,
            },
            swap: {
               upload_file: '',
               upload_title: '',
               selectedBlockchain: 'None',
            }
         }
      },
      mixins: [timerMixin],
      components: {
         appListOfBlockchains: ListOfBlockchains
      },
      methods: {
         onUpload(event) {
            if (event.target.files[0].name) {
               this.swap.upload_file = event.target.files[0];
               this.swap.upload_title = event.target.files[0].name;
               this.startUploading();
            }
         },
         proceedToCompilling() {

            const fields = {
               type: 'TIMEPROOF',
               fullpage: '---',
               blockchain: this.swap.selectedBlockchain,
               activate_js: '---',
            };

            this.$store.dispatch(SAVE_REPORT_FIELDS, fields);
            this.$store.dispatch(SAVE_TEMP_PDF_FILE, this.swap.upload_file);
            this.$store.dispatch(CHANGE_COMPONENT, 'appReportTimeproofCompilling');
         }
      },
      mounted() {
         bus.$on('emit_selected_blockchain', (bc) => {
            this.swap.selectedBlockchain = bc;
         });
         bus.$on('emit_done_uploading', () => {
            this.utils.is_upload_done = true;
         });
      }
   }
</script>


<style scoped>
    .file-upload input[type='file'] {
        display: none;
    }

    .disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    .error {
        color: red;
        font-size: 10px;
        padding-top: 3px;
    }
</style>